import { useEffect, useState } from "react";
import { useLocation, useParams } from "react-router-dom";
import { RESET_LOADER, SET_LOADER } from "../../../constants/contexConstant";
import { PROPOSAL_DOCUMENT_META_ENDPOINT } from "../../../constants/routes";
import { useContextState } from "../../../context/ContextProvider";
import request from "../../../services/request";
import DetailsHolder from "../proposalDetails/DetailsHolder";
import PurchaseWrapper from "./PurchaseWrapper";

const PurchaseProposalDetails = () => {
    const { plantId } = useParams();
    const { proposalId } = useParams();
    const [plant] = useState(plantId);
    const [proposal] = useState(proposalId);
    const location = useLocation();
    const { dispatch } = useContextState();
    const queryParams = new URLSearchParams(location.search);

    const isSubsidyParam = queryParams.get("isSubsidy");

    const isSubsidy = isSubsidyParam === "true";
    const [purchase, setPurchase] = useState(null);
    const endpoint = `${PROPOSAL_DOCUMENT_META_ENDPOINT}/${plant}/${proposal}`;

    const body = {
        type: "purchase",
        isSubsidy: isSubsidy,
    };
    const fetchData = async () => {
        try {
            dispatch({ type: SET_LOADER });
            const data = await request.authPost({
                endpoint: endpoint,
                body: body,
            });
            dispatch({ type: RESET_LOADER });
            setPurchase(data?.data?.data);
        } catch (error) {
            dispatch({ type: RESET_LOADER });
        }
    };

    useEffect(() => {
        fetchData();
    }, []);

    return (
        <DetailsHolder>
            <PurchaseWrapper purchase={purchase} />
        </DetailsHolder>
    );
};

export default PurchaseProposalDetails;
